import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import PageLayout from '../components/Layout';
import HeroHeader from '../components/Hero';
import { Helmet } from 'react-helmet';
import colors from '../styles/colors';
import { Row, Container, Col } from 'react-bootstrap';

const PageContent = ({ heroImage, className, content }) => (
  <div className={className}>
    <Container fluid>
      <Helmet>
        <title>Safety</title>
      </Helmet>
      <Row>
        <HeroHeader heroImage={heroImage} content={content.safety.heading} />
      </Row>
      <div className='page-content'>
        <Row>
          <Col xs={12} md={6}>
          <div className='leftColumn'>
            <h3>{content.safety.statement.heading}</h3>
            {content.safety.statement.text.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
          </Col>
          <Col xs={12} md={6}>
          <div className='rightColumn'>
            <h3>{content.safety.standards.heading}</h3>
            {content.safety.standards.text.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
          </Col>
        </Row>
      </div>
    </Container>
  </div>
);

const StyledPageContent = styled(PageContent)`
  /* display: flex; */
  h3 {
    text-transform: uppercase;
  }
  .page-content {
    display: flex;
    padding-right: 40px;
    @media screen and (max-width: 576px) {
      padding-right: 0;
    }

    .leftColumn {
      width: 100%;
      padding-left: 40px;
      padding-top: 40px;
      padding-right: 40px;
      background: ${colors.lightBlue};
      height: 100%;
      
    }
    .rightColumn {
      width: 100%;
      padding-top: 40px;
      padding-left: 40px;
      height: 100%;
      @media screen and (max-width: 576px) {
        padding-right: 40px;
      }
    }
  }
  .heading-background {
    max-width: 320px;
    .heading {
      width: 100%;
      margin-left: 40px;
    }
  }
`;

const SafetyPage = ({ data, content }) => (
  <PageLayout>
    <StyledPageContent
      heroImage={data.header.childImageSharp.fluid}
      content={content}
    />
  </PageLayout>
);

export const query = graphql`
  query {
    header: file(relativePath: { eq: "hero_safety.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

export default SafetyPage;
